export enum GACategories {
  gamePlanCreator = "Create game plan",
  gamePlanDetails = "Game plan details",
  gamePlanEditor = "Edit game plan",
  gamePlanOverview = "Game plan overview",
  tasks = "Tasks"
}

export enum GAActions {
  addTask = "Add task",
  assignTask = "Assign task",
  cancel = "Cancel",
  changeDescription = "Change description",
  changeKPITarget = "Change KPI target",
  changeObjective = "Change objective",
  changeTask = "Change task",
  changeTaskOrder = "Change task order",
  changeTime = "Change time",
  closeChart = "Close chart",
  closeGamePlan = "Close game plan",
  createGamePlan = "Create game plan",
  deleteGamePlan = "Delete game plan",
  deleteTask = "Delete task",
  editGamePlan = "Edit game plan",
  goToActive = "Go to active",
  goToCreateGamePlan = "Go to 'Create a game plan'",
  goToPrevious = "Go to previous game plans",
  goToStep = "Go to step",
  hoverHelp = "Hover help",
  markTask = "Mark task",
  nextStep = "Next step",
  openAssigneeSelector = "Open assignee selector",
  openChart = "Open chart",
  openDueDateSelector = "Open due date selector",
  openGamePlan = "Open game plan",
  openKPISelector = "Open KPI selector",
  previousStep = "Previous step",
  selectFarm = "Select farm",
  selectKPI = "Select KPI",
  selectTarget = "Select target",
  setDueDate = "Set due date",
  unmarkTask = "Unmark task",
  updateGamePlan = "Update game plan"
}

export enum GALabels {
  hasTarget = "Has target",
  hasNoTarget = "Has no target"
}
